import React from 'react';
import { useTranslation } from 'react-i18next';
import { Quill } from 'react-quill';

const Size = Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

const Font = Quill.import('attributors/style/font');
Font.whitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lucida'];
Quill.register(Font, true);

export const modules = {
  toolbar: {
    container: '#toolbar',
  },
  clipboard: { matchVisual: false },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

const Link = Quill.import('formats/link');
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel', 'radar', 'rdar', 'smb', 'sms'];
class CustomLinkSanitizer extends Link {
  static sanitize(url) {
    const sanitizedUrl = super.sanitize(url);
    if (!sanitizedUrl || sanitizedUrl === 'about:blank') {
      return sanitizedUrl;
    }
    const hasWhitelistedProtocol = this.PROTOCOL_WHITELIST.some((protocol) => sanitizedUrl.startsWith(protocol));
    if (hasWhitelistedProtocol) {
      return sanitizedUrl;
    }
    return `http://${sanitizedUrl}`;
  }
}

Quill.register(CustomLinkSanitizer, true);
export const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'script',
  'blockquote',
  'background',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'code-block',
];

export const QuillToolbar = ({ customId }) => {
  const { t } = useTranslation('common');
  const id = customId || 'toolbar';
  return (
    <div id={id}>
      <span className="ql-formats">
        <select className="ql-header" defaultValue="3">
          <option value="1">{t('editor.heading')}</option>
          <option value="2">{t('editor.subheading')}</option>
          <option value="3">{t('editor.normal')}</option>
        </select>
      </span>
      <span className="ql-formats">
        <button className="ql-bold" type="button" aria-label="bold-btn" />
        <button className="ql-italic" type="button" aria-label="italic-btn" />
        <button className="ql-link" type="button" aria-label="link-btn" />
      </span>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" type="button" aria-label="ol-list-btn" />
        <button className="ql-list" value="bullet" type="button" aria-label="ul-list-btn" />
      </span>
    </div>
  );
};

export default QuillToolbar;
